/* amantani-promo.js
   ===================
   Inicializa el banner de promo de pantuflas (.amn-promo) en cualquier contexto:
   - Ficha de producto (conjuntos en promo).
   - Cart drawer (cuando hay un conjunto en el carrito).
   Como el cart drawer se refresca por AJAX (innerHTML, que NO ejecuta <script>),
   este archivo se carga una vez por página (desde theme.liquid) y re-inicializa
   cualquier .amn-promo nuevo que aparezca, observando el contenedor del drawer.
*/
(function () {
  'use strict';

  function escHtml(s){ return s==null?'':String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function escAttr(s){ return s==null?'':String(s).replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }

  function initBufandaSliders(root) {
    (root || document).querySelectorAll('.amn-gift__slider:not([data-amnbuf-rdy])').forEach(function(slider) {
      slider.setAttribute('data-amnbuf-rdy', '1');
      var track = slider.querySelector('.amn-gift__track');
      if (!track) return;
      var step = 65; // 58px thumb + 7px gap
      var prev = slider.querySelector('[data-amnbuf-prev]');
      var next = slider.querySelector('[data-amnbuf-next]');
      if (prev) prev.addEventListener('click', function() { track.scrollBy({ left: -step * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function() { track.scrollBy({ left: step * 2, behavior: 'smooth' }); });
    });
  }

  function initAll(root){
    (root || document).querySelectorAll('.amn-promo:not([data-amn-ready])').forEach(initPromo);
    initBufandaSliders(root);
    initVolumen(root);
  }

  /* ─────────────────────────────────────────────────────────────────────────
     Volume discount "Compra más, ahorra más" (Panty efecto piel) — propio,
     reemplaza el módulo de Vitals. El widget (.amn-vol) sincroniza la cantidad
     con el form de compra; el descuento real lo aplica un código nativo que
     sembramos según las unidades de panty en el carrito.
     Si cambian producto/códigos/tramos, editar SOLO este bloque.
  ───────────────────────────────────────────────────────────────────────── */
  var VOL_CFG = {
    activo: !!(window.AMN_PROMOS && window.AMN_PROMOS.volumen_piel),  // switch 'volumen_piel' de /config
    productId: 7595798397011,                 // Panty efecto piel
    tiers: [                                  // de mayor a menor: se elige el primero que cumpla
      { min: 3, code: 'PIEL20' },             // 3+ -> 20%
      { min: 2, code: 'PIEL10' }              // 2  -> 10%
    ]
  };

  // Selecciona un tramo -> fija la cantidad en el stepper visible y en el form de compra.
  function initVolumen(root){
    (root || document).querySelectorAll('.amn-vol:not([data-amn-vol-ready])').forEach(function(box){
      box.setAttribute('data-amn-vol-ready', '1');
      var radios = Array.prototype.slice.call(box.querySelectorAll('input[name="amn-vol-tier"]'));
      if (!radios.length) return;

      function markSelected(qty){
        box.querySelectorAll('.amn-vol__opt').forEach(function(o){
          o.classList.toggle('is-selected', parseInt(o.getAttribute('data-qty'), 10) === qty);
        });
      }

      function setQty(qty){
        // stepper visible (lo escucha el tema) + hidden .formQty del form de compra
        document.querySelectorAll('.js-qty-input, .formQty, input[name="quantity"]').forEach(function(inp){
          if (String(inp.value) === String(qty)) return;
          inp.value = qty;
          inp.dispatchEvent(new Event('input',  { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
        markSelected(qty);
      }

      radios.forEach(function(r){
        r.addEventListener('change', function(){
          if (r.checked) setQty(parseInt(r.getAttribute('data-qty'), 10) || 1);
        });
      });

      // Si el cliente toca el stepper manualmente, reflejarlo en los tramos.
      var stepper = document.querySelector('.js-qty-input');
      if (stepper){
        stepper.addEventListener('change', function(){
          var q = parseInt(stepper.value, 10) || 1;
          radios.forEach(function(r){ r.checked = (parseInt(r.getAttribute('data-qty'), 10) === q); });
          markSelected(q);
        });
      }

      // Estado inicial (tramo marcado en el HTML, por defecto 1).
      var checked = box.querySelector('input[name="amn-vol-tier"]:checked') || radios[0];
      markSelected(parseInt(checked.getAttribute('data-qty'), 10) || 1);
    });
  }

  // Siembra el código de descuento que corresponde a las unidades de panty en el carrito.
  // El código se aplica a la sesión del carrito y se respeta en el checkout.
  // Los códigos llevan "cantidad mínima", así que si no se cumple el tramo no se aplica.
  // Redibuja el cart drawer con el estado real del carrito (mismo mecanismo que
  // addToCartAndShow). En /cart sin ajaxCart, recarga la pagina. v2-sync-ui.
  function amnRefreshCartView(){
    try {
      var aj = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;
      var cart = window.Shopify && Shopify.theme && Shopify.theme.cart;
      var cfgEl = document.getElementById('cart-config');
      if (aj && cart && cart.getCart && cfgEl){
        var config; try { config = JSON.parse(cfgEl.innerHTML || '{}'); } catch(e){ config = {}; }
        cart.getCart().then(function(Cart){ try { aj.updateView(config, Cart); } catch(e){} });
        return;
      }
      if (location.pathname.indexOf('/cart') === 0) location.reload();
    } catch(e){}
  }

  // Sincroniza el codigo de volumen (PIEL10/PIEL20) con las pantys PAGADAS del carrito.
  // - La panty REGALADA (PantyGratis) no cuenta para el tramo 2=10% / 3=20%.
  // - `applied` se lee de cart.discount_codes (la SESION): tambien detecta codigos
  //   presentes pero sin aplicar (applicable:false). Fallback: allocations por linea.
  // - Si el carrito BAJA de tramo, se QUITA el codigo pegado (POST /cart/update.js
  //   {discount:''}); /cart/clear.js NO lo limpia. Los codigos no stackean y gana el
  //   de mayor %: para pasar de PIEL20 a PIEL10 hay que limpiar y recien sembrar.
  // - Tras limpiar/sembrar se redibuja el drawer (des-sembrar visible al instante).
  function seedVolumenDiscount(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var qty = 0, applied = null;
        (cart.discount_codes || []).forEach(function(d){
          var c = String(d.code || '').toUpperCase();
          if (c === 'PIEL10' || c === 'PIEL20') applied = c;
        });
        (cart.items || []).forEach(function(it){
          var allocs = (it.line_level_discount_allocations || []).concat(it.discounts || []);
          if (!applied){
            allocs.forEach(function(a){
              var t = (a.title || (a.discount_application && a.discount_application.title) || '').toUpperCase();
              if (t === 'PIEL10' || t === 'PIEL20') applied = t;
            });
          }
          if (it.product_id !== VOL_CFG.productId) return;
          // Excluir las unidades REGALADAS por la promo del banner (PantyGratis):
          // la panty de regalo NO cuenta para el tramo.
          var freeAmt = 0;
          allocs.forEach(function(a){
            var t = (a.title || (a.discount_application && a.discount_application.title) || '').toLowerCase();
            if (t.indexOf('pantygratis') !== -1 || t.indexOf('panty gratis') !== -1) freeAmt += (parseFloat(a.amount) || 0);
          });
          var unit = it.price || it.original_price || 0;
          var freeUnits = unit ? Math.round(freeAmt / unit) : 0;
          var paid = it.quantity - freeUnits;
          if (paid > 0) qty += paid;
        });
        var code = null;
        for (var i = 0; VOL_CFG.activo !== false && i < VOL_CFG.tiers.length; i++){
          if (qty >= VOL_CFG.tiers[i].min){ code = VOL_CFG.tiers[i].code; break; }
        }
        if (code === applied) return;   // ya esta en sync, nada que hacer
        var clear = function(){
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
        };
        var seed = function(){
          return fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });
        };
        if (!code){ clear().then(amnRefreshCartView).catch(function(){}); return; }
        if (applied){ clear().then(seed).then(amnRefreshCartView).catch(function(){}); }
        else { seed().then(amnRefreshCartView).catch(function(){}); }
      })
      .catch(function(){});
  }

  function initPromo(promo){
    promo.setAttribute('data-amn-ready', '1');
    var cards = promo.querySelectorAll('.amn-promo__card');

    cards.forEach(function(card){
      var variants;
      try { variants = JSON.parse(card.querySelector('.js-amn-variants').textContent); }
      catch(e){ variants = []; }

      var colorIdx = parseInt(card.getAttribute('data-color-idx'),10) || 0; // 1,2,3 o 0=no aplica
      var sizeIdx  = parseInt(card.getAttribute('data-size-idx'),10) || 0;
      var colorSel = card.querySelector('.js-amn-color');
      var sizeSel  = card.querySelector('.js-amn-size');
      var btn      = card.querySelector('.js-amn-add');
      if (!colorSel || !sizeSel || !btn) return;

      function optVal(v, idx){ return idx === 1 ? v.o1 : idx === 2 ? v.o2 : idx === 3 ? v.o3 : null; }

      if (colorIdx){
        var colors = [];
        variants.forEach(function(v){
          var c = optVal(v, colorIdx);
          if (c != null && colors.indexOf(c) === -1) colors.push(c);
        });
        colorSel.innerHTML = colors.map(function(c){
          var has = variants.some(function(v){ return optVal(v,colorIdx)===c && v.available; });
          return '<option value="'+escAttr(c)+'"'+(has?'':' disabled')+'>'+escHtml(c)+(has?'':' (sin stock)')+'</option>';
        }).join('');
        var firstOk = colors.find(function(c){ return variants.some(function(v){ return optVal(v,colorIdx)===c && v.available; }); });
        if (firstOk != null) colorSel.value = firstOk;
      } else {
        colorSel.style.display = 'none';
      }

      function refreshSizes(){
        if (!sizeIdx){ sizeSel.style.display='none'; return; }
        var selColor = colorIdx ? colorSel.value : null;
        var sizes = [];
        variants.forEach(function(v){
          if (colorIdx && optVal(v,colorIdx) !== selColor) return;
          var s = optVal(v, sizeIdx);
          if (s != null && sizes.indexOf(s) === -1) sizes.push(s);
        });
        sizeSel.innerHTML = sizes.map(function(s){
          var has = variants.some(function(v){
            return (!colorIdx || optVal(v,colorIdx)===selColor) && optVal(v,sizeIdx)===s && v.available;
          });
          return '<option value="'+escAttr(s)+'"'+(has?'':' disabled')+'>'+(sizeIdx?'Talla ':'')+escHtml(s)+(has?'':' (agotada)')+'</option>';
        }).join('');
        var firstOk = sizes.find(function(s){
          return variants.some(function(v){ return (!colorIdx || optVal(v,colorIdx)===selColor) && optVal(v,sizeIdx)===s && v.available; });
        });
        if (firstOk != null) sizeSel.value = firstOk;
        updateBtn();
      }

      function currentVariant(){
        var selColor = colorIdx ? colorSel.value : null;
        var selSize  = sizeIdx  ? sizeSel.value  : null;
        return variants.find(function(v){
          return (!colorIdx || optVal(v,colorIdx)===selColor) &&
                 (!sizeIdx  || optVal(v,sizeIdx)===selSize);
        });
      }

      function updateBtn(){
        var v = currentVariant();
        if (v && v.available){ btn.disabled = false; btn.textContent = btn.getAttribute('data-default'); }
        else { btn.disabled = true; btn.textContent = 'Sin stock'; }
      }

      colorSel.addEventListener('change', refreshSizes);
      sizeSel.addEventListener('change', updateBtn);
      refreshSizes();

      btn.addEventListener('click', function(){
        var v = currentVariant();
        if (!v || !v.available) return;
        var orig = btn.getAttribute('data-default');
        btn.disabled = true; btn.textContent = 'Agregando…';

        addToCartAndShow(v.id).then(function(){
          btn.classList.add('amn-promo__btn--ok'); btn.textContent = '✓ Agregada';
          document.dispatchEvent(new CustomEvent('amantani-cart-updated'));
          setTimeout(function(){
            btn.classList.remove('amn-promo__btn--ok'); btn.textContent = orig;
            updateBtn();
          }, 2500);
        }).catch(function(){
          btn.classList.add('amn-promo__btn--err'); btn.textContent = 'Reintentar';
          setTimeout(function(){ btn.classList.remove('amn-promo__btn--err'); updateBtn(); }, 2000);
        });
      });
    });
  }

  // Agrega al carrito y refresca/abre el cart drawer del tema.
  // El descuento es automático en Shopify (Compra conjunto → pantufla con dcto).
  function addToCartAndShow(variantId){
    return fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(r){
      if (!r.ok) return r.json().then(function(e){ throw e; });
      return r.json();
    }).then(function(){
      var aj = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;
      var cart = window.Shopify && Shopify.theme && Shopify.theme.cart;
      var cfgEl = document.getElementById('cart-config');
      if (aj && cart && cart.getCart && cfgEl){
        var config; try { config = JSON.parse(cfgEl.innerHTML || '{}'); } catch(e){ config = {}; }
        return cart.getCart().then(function(Cart){
          try { aj.updateView(config, Cart); } catch(e){}
          try { aj.showDrawer(config); } catch(e){}
          try { aj.showModal(config); }  catch(e){}
        });
      }
      window.location.href = '/cart';
    });
  }

  // ── Arranque + re-inicialización tras refrescos AJAX del drawer ──
  function boot(){
    initAll();
    seedVolumenDiscount();

    // Re-init cuando el contenido del cart drawer cambia (innerHTML por AJAX)
    var pending = false;
    function schedule(){
      if (pending) return;
      pending = true;
      setTimeout(function(){ pending = false; initAll(); seedVolumenDiscount(); }, 80);
    }
    var obs = new MutationObserver(schedule);
    var targets = document.querySelectorAll('.js-ajax-cart-content, .ajax-cart__drawer-wrapper, .js-cart-form');
    if (targets.length){
      targets.forEach(function(t){ obs.observe(t, { childList:true, subtree:true }); });
    } else {
      obs.observe(document.body, { childList:true, subtree:true });
    }

    // Por las dudas, también al recibir el evento propio del tema/recs
    document.addEventListener('amantani-cart-updated', schedule);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
